const API_URL = process.env.REACT_APP_API_ROOT || 'http://localhost:8000/api';
const API_ORIGIN = API_URL.replace(/\/api\/?$/, '');
const TOKEN_KEY = 'leora_admin_token';

let authToken = localStorage.getItem(TOKEN_KEY) || null;
let onUnauthorized = null;

export function setAuthToken(token) {
  authToken = token;
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}

export function getAuthToken() {
  return authToken || localStorage.getItem(TOKEN_KEY);
}

export function setOnUnauthorized(callback) {
  onUnauthorized = callback;
}

function buildHeaders(isJson = true) {
  const headers = {};
  if (isJson) {
    headers['Content-Type'] = 'application/json';
  }
  const token = getAuthToken();
  if (token) {
    headers.Authorization = `Token ${token}`;
  }
  return headers;
}

async function handleResponse(response) {
  if (response.status === 401 && onUnauthorized) {
    onUnauthorized();
  }
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    const detail = error.detail;
    const detailText = Array.isArray(detail) ? detail[0] : detail;
    const firstField = Object.values(error).flat?.()?.[0];
    throw new Error(detailText || firstField || error.message || `HTTP Error: ${response.status}`);
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
}

export async function get(endpoint) {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'GET',
    headers: buildHeaders(),
  });
  return handleResponse(response);
}

export async function post(endpoint, data) {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(response);
}

export async function put(endpoint, data) {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'PUT',
    headers: buildHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(response);
}

export async function del(endpoint) {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'DELETE',
    headers: buildHeaders(),
  });
  return handleResponse(response);
}

export async function patch(endpoint, data) {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'PATCH',
    headers: buildHeaders(),
    body: JSON.stringify(data),
  });
  return handleResponse(response);
}

export async function uploadFormData(endpoint, formData, method = 'POST') {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method,
    headers: buildHeaders(false),
    body: formData,
  });
  return handleResponse(response);
}

export function resolveMediaUrl(url) {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/')) return `${API_ORIGIN}${url}`;
  return `${API_ORIGIN}/${url}`;
}

const api = {
  get,
  post,
  put,
  del,
  patch,
  uploadFormData,
  setAuthToken,
  getAuthToken,
  setOnUnauthorized,
};

export default api;
